export default "__VITE_ASSET__b5d7d841__"